import React from 'react';
import PropTypes from 'prop-types';

const FlagIcon = ({ locale, size = 24 }) => {
  const width = size * 1.33; // 4:3 aspect ratio
  const height = size;
  
  const flags = {
    en: (
      <svg width={width} height={height} viewBox="0 0 42 32">
        <rect width="42" height="32" fill="#012169" />
        <path d="M0 0l42 32M42 0L0 32" stroke="#fff" strokeWidth="6" />
        <path d="M0 0l42 32M42 0L0 32" stroke="#C8102E" strokeWidth="4" />
        <path d="M21 0v32M0 16h42" stroke="#fff" strokeWidth="10" />
        <path d="M21 0v32M0 16h42" stroke="#C8102E" strokeWidth="6" />
      </svg>
    ),
    es: (
      <svg width={width} height={height} viewBox="0 0 42 32">
        <rect width="42" height="8" fill="#AA151B" />
        <rect y="8" width="42" height="16" fill="#F1BF00" />
        <rect y="24" width="42" height="8" fill="#AA151B" />
      </svg>
    ),
    fr: (
      <svg width={width} height={height} viewBox="0 0 42 32">
        <rect width="14" height="32" fill="#002395" />
        <rect x="14" width="14" height="32" fill="#fff" />
        <rect x="28" width="14" height="32" fill="#ED2939" />
      </svg>
    ),
    it: (
      <svg width={width} height={height} viewBox="0 0 42 32">
        <rect width="14" height="32" fill="#009246" />
        <rect x="14" width="14" height="32" fill="#fff" />
        <rect x="28" width="14" height="32" fill="#CE2B37" />
      </svg>
    ),
    de: (
      <svg width={width} height={height} viewBox="0 0 42 32">
        <rect width="42" height="10.67" fill="#000" />
        <rect y="10.67" width="42" height="10.67" fill="#D00" />
        <rect y="21.33" width="42" height="10.67" fill="#FFCE00" />
      </svg>
    ),
    pl: (
      <svg width={width} height={height} viewBox="0 0 42 32">
        <rect width="42" height="16" fill="#fff" />
        <rect y="16" width="42" height="16" fill="#DC143C" />
      </svg>
    ),
    pt: (
      <svg width={width} height={height} viewBox="0 0 42 32">
        <rect width="17" height="32" fill="#006600" />
        <rect x="17" width="25" height="32" fill="#FF0000" />
        <circle cx="17" cy="16" r="7" fill="none" stroke="#FFCC00" strokeWidth="1.5" />
        <path d="M13 11h8v8a4 4 0 0 1-8 0z" fill="#fff" stroke="#CC0000" strokeWidth="2" />
        <path d="M17 13v7M15 16h4" stroke="#003399" strokeWidth="1.5" />
      </svg>
    ),
    ru: (
      <svg width={width} height={height} viewBox="0 0 42 32">
        <rect width="42" height="10.67" fill="#fff" />
        <rect y="10.67" width="42" height="10.67" fill="#0039A6" />
        <rect y="21.33" width="42" height="10.67" fill="#D52B1E" />
      </svg>
    ),
  };

  return flags[locale] || null;
};

FlagIcon.propTypes = {
  locale: PropTypes.string.isRequired,
  size: PropTypes.number,
};

export default FlagIcon;
